(function () {
  'use strict';

  function init(root) {
    if (!root || root.dataset.accordionFigmaInit === 'true') return;
    root.dataset.accordionFigmaInit = 'true';

    const items = root.querySelectorAll('[data-accordion-figma-item]');
    if (!items.length) return;

    const setOpen = function (item, open) {
      const trigger = item.querySelector('[data-accordion-figma-trigger]');
      const panel = item.querySelector('[data-accordion-figma-panel]');
      item.classList.toggle('is-open', open);
      if (trigger) {
        trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
      }
      if (panel) {
        panel.setAttribute('aria-hidden', open ? 'false' : 'true');
      }
    };

    items.forEach(function (item) {
      const trigger = item.querySelector('[data-accordion-figma-trigger]');
      if (!trigger) return;

      trigger.addEventListener('click', function () {
        const isOpen = item.classList.contains('is-open');
        if (isOpen) {
          items.forEach(function (other) {
            setOpen(other, false);
          });
        } else {
          items.forEach(function (other) {
            setOpen(other, other === item);
          });
        }
      });
    });
  }

  function syncMaterialFromVariant(variant) {
    if (!variant) return;
    const material =
      (variant.option1 && String(variant.option1).trim()) ||
      (Array.isArray(variant.options) && variant.options[0] ? String(variant.options[0]).trim() : '');
    if (!material) return;
    document.querySelectorAll('[data-accordion-material]').forEach(function (el) {
      el.textContent = material;
    });
  }

  function bindVariantSync() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    if (window.__accordionFigmaVariantBound) return;
    window.__accordionFigmaVariantBound = true;

    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      const variant = event && event.data && event.data.variant;
      syncMaterialFromVariant(variant);
    });
  }

  document.querySelectorAll('[data-accordion-figma]').forEach(init);
  bindVariantSync();

  window.initProductAccordionFigma = function (root) {
    if (root) {
      root.dataset.accordionFigmaInit = '';
      init(root);
      return;
    }
    document.querySelectorAll('[data-accordion-figma]').forEach(function (el) {
      el.dataset.accordionFigmaInit = '';
      init(el);
    });
  };

  document.addEventListener('shopify:section:load', function (ev) {
    const r = ev.target && ev.target.querySelector && ev.target.querySelector('[data-accordion-figma]');
    if (r) {
      r.dataset.accordionFigmaInit = '';
      init(r);
    }
  });
})();
